var $ = jQuery.noConflict();

$(window).on('load', function() {
  var count_elements,count_new_elements;

   var interval = setInterval(() => {
     
        $('.grid-carousel-item .product-name').matchHeight({
          byRow: true,
          property: 'height',
          target: null,
          remove: false
        }).addClass('mht');
    
       if($('.grid-carousel-item .product-name').hasClass('mht')){
           clearInterval(interval);
           replaceHTMLCharacterEntities();
        }
    
    },300)

   var interval1 = setInterval(() => {
        $('.products-collection-grid .product-name').matchHeight({
          byRow: true,
          property: 'height',
          target: null,
          remove: false
        }).addClass('mht');
    
       if($('.products-collection-grid .product-name').hasClass('mht')){
           clearInterval(interval1);
           $('.products-collection-grid .product-name').removeClass('mht');
           count_elements = $('.products-collection-grid li').length;
           replaceHTMLCharacterEntities();
        }
    
    },300)
  
   var interval2 = setInterval(() => {
        $('.section-collection-list .grid-carousel-item').each(function(key, value){
            if (key == 0 || key == 2) {
                $(this).find('.heading').addClass("bg11");
            }else{
                $(this).find('.heading').addClass("bg22");
            }
        }).addClass('mht');
    
       if($('.section-collection-list .grid-carousel-item').hasClass('mht')){
           clearInterval(interval2);
           replaceHTMLCharacterEntities();
        }
    
    },300)



  $(document).on('click','.pagination-load-more a.button',function(){
     var interval11 = setInterval(() => {
          count_new_elements = $('.products-collection-grid li').length;
           if(count_new_elements > count_elements){
            $('.products-collection-grid .product-name').matchHeight({
              byRow: true,
              property: 'height',
              target: null,
              remove: false
            });
             count_elements = count_new_elements;
             clearInterval(interval11);
             replaceHTMLCharacterEntities();
           }
      },300)
 });

$(document).on('change', '.cart-form', function() {
  setTimeout(function() {
    replaceHTMLCharacterEntities();
   }, 1600);
});

$(document).on('click','*[data-button-remove]',function(){
  setTimeout(function() {
    replaceHTMLCharacterEntities();
   }, 1600);
});

  
var replaceHTMLCharacterEntities = function () {
    $('h1,h2,h3,h4,p,h2 a,.grow a').each(function(i, elem) {
        $(elem).html(function(i, html) {
            return html.replace(/((?!<sup>\s*))®((?!\s*<\/sup>))/gi, '<sup>&reg;</sup>').replace(/((?!<sup>\s*))&reg;((?!\s*<\/sup>))/gi, '<sup>&reg;</sup>');
        });
    });
}

  
replaceHTMLCharacterEntities();


  
});



